import { styled } from "goober";
import type { MarkdownItem as MarkdownItemType } from "../../../shared/connectors/types";
import { Markdown } from "../Markdown";
import { Text } from "../Text";
import { useRenderWithPlaceholders } from "./renderWithPlaceholders";

const Container = styled("div")`
  color: var(--text-secondary);

  p:not(:first-child) {
    margin-top: 16px;
  }

  a {
    color: var(--text-primary);
  }

  strong {
    font-weight: 450;
  }
`;

type Props = {
  item: MarkdownItemType;
  configuration: Record<string, string>;
};

export function MarkdownItem({ item, configuration }: Props) {
  const renderWithPlaceholders = useRenderWithPlaceholders();
  const content =
    typeof item.content === "function"
      ? item.content(configuration)
      : item.content;

  return (
    <Container>
      <Text variant="text-regular">
        <Markdown>{renderWithPlaceholders(content, configuration)}</Markdown>
      </Text>
    </Container>
  );
}
